export enum DocumentTypeEnum {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
}
